import initContentReadingTracking from '../../../analytics/src/datalayer-content-reading-tracking';
import addUrlParameterToUrl from '../helpers/add-url-parameter-to-url';
import removeParamsFromUrl from '../helpers/remove-params-from-url';
import getUrlParameterByName from '../helpers/get-url-parameter-by-name';
import removeArticleAds from '../helpers/remove-article-ads';
import * as dataLayerConstants from '../../../analytics/src/datalayer/constants';

function updateLinkhref ( originalhref, newhref, addParams = false ) {
	const pageUrl = new URL( window.location.href ); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
	let updatedUrl = newhref;

	if ( addParams ) {
		updatedUrl = addUrlParameterToUrl( newhref, '_target_path', removeParamsFromUrl( pageUrl ) );

		const ptid = getUrlParameterByName( '_ptid', originalhref );
		if ( ptid ) {
			updatedUrl = addUrlParameterToUrl( updatedUrl, '_ptid', ptid );
		}
	}

	return updatedUrl;
}
function updateButton ( element, buttonData, addParams = false, gaLabel, eventType ) {
	element.href = updateLinkhref( element.href, buttonData.buttonLink, addParams );
	updateDataLayerEvents( element, buttonData.buttonText, eventType, 'button', gaLabel );
	element.textContent = buttonData.buttonText;
}

function updateElement ( element, string, mayContainLink = false, gaLabel, eventType ) {
	if ( mayContainLink ) {
		// Capture the original href to extract parameters later if needed
		const originalLinkElement = element.querySelector( 'a' );
		const originalhref = originalLinkElement ? originalLinkElement.href : '';

		// Update the content
		element.innerHTML = string; // phpcs:ignore WordPressVIPMinimum.JS.InnerHTML.Found

		// Use the new link element
		const linkElement = element.querySelector( 'a' );
		if ( linkElement ) {
			// Apply the parameters from the original href to the new href
			const updatedUrl = updateLinkhref( originalhref, linkElement.getAttribute( 'href' ), mayContainLink );
			linkElement.setAttribute( 'href', updatedUrl );

			updateDataLayerEvents( linkElement, linkElement.innerText, eventType, 'link', gaLabel );
		}
	} else {
		element.innerHTML = string; // phpcs:ignore WordPressVIPMinimum.JS.InnerHTML.Found
	}
}

function updateTerms ( element, termsData ) {
	element.textContent = '';
	for ( const term of termsData ) {
		const termElement = document.createElement( 'p' );
		termElement.classList.add( 'Barrier__SmallPrint' );
		termElement.textContent = term;
		element.appendChild( termElement );
	}
}

function updateDataLayerEvents ( element, linkText, eventType, type, gaLabel ) {
	const event = {
		event: 'paywall',
		event_action: 'click',
		event_type: eventType,
		event_object_name: type,
		event_object_text: linkText,
		event_label: gaLabel,
		piano_label: gaLabel,
		service_platform: dataLayerConstants.SERVICE_PLATFORM_PIANO,
	};

	element.addEventListener( 'click', function () {
		dataLayer.push( event );
	} );
}

export const payWallDisplayed = messageParts => {
	const paywallContent = JSON.parse( messageParts[ 1 ] );

	// List elements
	const paywallElement = document.querySelector( '#subscription-barrier' );
	const heading = paywallElement.querySelector( '#paywall-heading' );
	const subscribeButton = paywallElement.querySelector( '#subscription-button' );
	const tsAndCs = paywallElement.querySelector( '#paywall-ts-and-cs' );
	const secondaryHeading = paywallElement.querySelector( '#paywall-secondary-heading' );
	const signInButton = paywallElement.querySelector( '#sign-in-button' );
	// Update elements
	updateElement( heading, paywallContent.paywallHeading, true, paywallContent.gaLabel );
	updateButton( subscribeButton, paywallContent.button, true, paywallContent.gaLabel, 'subscribe' );
	updateTerms( tsAndCs, paywallContent.termsAndConditions );
	updateElement( secondaryHeading, paywallContent.existingSubscribersHeading );
	updateDataLayerEvents(
		signInButton,
		signInButton.innerText,
		'sign in',
		'sign in button',
		paywallContent.gaLabel,
	);

	if ( 'RTA' in window ) {
		window.RTA.updateReport( { paywallStatus: 'isPaywalled' } );
	}

	subscribeButton.addEventListener( 'click', function () {
		if ( 'RTA' in window ) {
			window.RTA.pageEvent( { paywall_signup_article: 1 } );
			window.RTA.defer( 'paywall' );
		}
	} );

	removeArticleAds();

	initContentReadingTracking();
};

export default payWallDisplayed;
